export const getReferredLink = (referralCode: string) =>
  `${window.location.origin}/signUp/referralCode/${referralCode}`;
